import { Button } from '@/components/form/baseInputs/Button';
import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { ROUTE_KEYS } from '@/navigation/constants';

export function ManageDispositionsButton() {
  const { householdId } = useHouseholdDetailsContext();
  const { navigate } = useNavigateToRoute();

  if (!householdId) {
    return null;
  }

  const routeKey = ROUTE_KEYS.HOUSEHOLD_ESTATE_MANAGE_DISPOSITIONS;

  return (
    <Button
      data-testid="ManageDispositionsButton"
      variant="secondary"
      size="sm"
      onClick={() =>
        navigate(routeKey, {
          householdId,
        })
      }
    >
      Manage dispositions
    </Button>
  );
}
